/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportCatalogListRequest {
    getFixupPrototypeFunction() { return ReportCatalogListRequest.fixupPrototype; }

    static newInstance(model: Partial<ReportCatalogListRequest>): ReportCatalogListRequest {
        let obj = Object.assign(new ReportCatalogListRequest(), model);
        ReportCatalogListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportCatalogListRequest>): ReportCatalogListRequest {
        if (!model) return null;
        return ReportCatalogListRequest.newInstance(<ReportCatalogListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportCatalogListRequest) {
        if (!obj) return;

        models.ReportCatalogListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportCatalogListRequest): boolean {
        Object.setPrototypeOf(obj, ReportCatalogListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Catalog tab to load
     */
    scope: models.ReportCatalogScope;

    /**
     * Case-insensitive report title search; matches anywhere in the name
     */
    search: string;

    /**
     * Tenants to evaluate for the pinned and my_reports scopes. Defaults to the active tenant
     */
    tenant_ids: Array<string>;

}
